import { render } from "./opRateStatistics.vue?vue&type=template&id=2a90d3ec"
import script from "./opRateStatistics.vue?vue&type=script&lang=js"
export * from "./opRateStatistics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__